"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowComp = exports.Navigation = exports.Slide = void 0;
const app_1 = require("@obvio/app");
const svg_1 = require("@obvio/svg");
exports.Slide = app_1.styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  max-height: 100vh;
`;
exports.Navigation = app_1.styled.div `
  position: relative;
  width: 100%;
`;
exports.ArrowComp = (0, app_1.styled)(svg_1.SvgChevronDown) `
  width: 30px;
  height: 30px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%)
    rotate(${(_, { $direction }) => ($direction === 'left' ? 90 : -90)}deg);
  cursor: pointer;
  left: ${(_, { $direction }) => ($direction === 'left' ? '5px' : 'auto')};
  right: ${(_, { $direction }) => ($direction === 'right' ? '5px' : 'auto')};
`;
